<template>
<!-- 城市合伙人 -->
<section class="viewContainer">
  <div v-show="isOrder" @listenEdit="showOrder">
    <!-- 搜索/查询 -->
    <div class="main_container">
      <div class="fuji" @click="show3 = !show3">
        <div class="goodslist1">
          <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
          <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
        </div>
        <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
      </div>
      <el-collapse-transition>
      <div v-show="show3">
        <el-form :model="filters" class="findform">
          <!-- 顶部搜索框 -->
          <el-form-item label="姓名：" style="display:flex;width:20%">
            <el-input v-model="filters.cityPartnerName" placeholder="请输入姓名 (20字以内)" maxlength="20" style="width:90%;"/>
          </el-form-item>
          <el-form-item label="手机号：" style="display:flex;width:20%">
            <el-input v-model="filters.partnerPhone" placeholder="请输入手机号" onkeyup="value=value.replace(/^\D*(\d*(?:\d{0})?).*$/g, '$1')" maxlength="11" style="width:90%;"/>
          </el-form-item>
          <el-form-item label="性别：" style="display:flex;width:20%;">
            <el-select v-model="filters.partnerGender" filterable placeholder="请选择" style="width:90%;">
              <el-option v-for="(item,index) in genderArr" :key="index" :label="item.Name" :value="item.Id" />
            </el-select>
          </el-form-item>
          <el-form-item label="所属城市：" style="display:flex;width:20%;">
            <el-cascader v-model="chengshi" placeholder="请选择城市" :options="csOptions"
            filterable clearable @change="handleChangesscs" style="width:90%;"/>
          </el-form-item>
          <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
        </el-form>
      </div>
      </el-collapse-transition>
    </div>
    <!-- table 列表 -->
    <div class="main_container">
      <section class="model_section">
        <p class="model_top_title">城市合作</p>
        <el-button type="danger" @click="addPartner()" style="float: right;margin: 5px 10px 0 0;">添加合伙人</el-button>
      </section>
      <div class="table_container">
        <el-table :data="dataList" stripe border>
          <el-table-column label="序号" align="center" width="68px">
            <template scope="scope">{{scope.$index + 1}}</template>
          </el-table-column>
          <el-table-column label="姓名" align="center">
            <template scope="scope">
              <span :title="scope.row.name">{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column label="手机号" align="center">
            <template scope="scope">{{scope.row.phone}}</template>
          </el-table-column>
          <el-table-column label="注册时间" align="center">
            <template scope="scope">{{scope.row.createTime}}</template>
          </el-table-column>
          <el-table-column label="所属城市" align="center">
            <template scope="scope">{{scope.row.address}}</template>
          </el-table-column>
          <el-table-column label="加盟费" align="center">
            <template scope="scope">{{scope.row.franchiseFee}}</template>
          </el-table-column>
          <el-table-column label="分红比例" align="center">
            <template scope="scope">{{scope.row.commissionRate}}</template>
          </el-table-column>
          <el-table-column label="收益" align="center">
            <template scope="scope">{{scope.row.profit}}</template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center">
            <template scope="scope">
              <span @click="cliSeePartner(scope.row)" class="handle"> <i class="el-icon-view"/> 查看 </span>
              <span @click="addPartner(scope.row)" class="handle"> <i class="el-icon-edit-outline"/> 编辑 </span>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
        :current-page="pageIndex" :page-size="10" :total="totalRowsCount" style="margin:10px 0;float:right"/>
      </div>
    </div>
  </div>
  <!-- 查看基本信息详情页 -->
  <div v-if="isSeePartnerPopup">
    <!-- 基本信息 -->
    <div class="main_container">
      <section class="model_section">
        <p class="model_top_title">用户详情</p>
        <el-button type="danger" @click="showOrder()" style="float: right;margin: 5px 10px 0 0;">返回</el-button>
      </section>
      <b style="font-size: 15px;line-height: 33px;padding-left: 20px;">基本信息</b>
      <div style="width:99%;margin: 0 auto;display:flex;flex-wrap: wrap;">
        <span class="typefaceSpan">
          <p style="white-space: nowrap;" class="watch_first">姓　　名 ：</p>
          <p style="width:85%;word-wrap: break-word;">{{essentialInformation.name}}</p>
        </span>
        <span class="typefaceSpan">
          <p style="white-space: nowrap;" class="watch_first">微　信　号 ：</p>
          <p style="width:85%;word-wrap: break-word;">{{essentialInformation.wechatCode}}</p>
        </span>
        <span class="typefaceSpan">
          <p style="white-space: nowrap;" class="watch_first">管辖地区 ：</p>
          <p style="width:85%;word-wrap: break-word;">{{essentialInformation.address}}</p>
        </span>
        <span class="typefaceSpan">
          <p style="white-space: nowrap;" class="watch_first">性　　别 ：</p>
          <p style="width:85%;word-wrap: break-word;">{{essentialInformation.sex}}</p>
        </span>
        <span class="typefaceSpan">
          <p style="white-space: nowrap;" class="watch_first">联系方式 ：</p>
          <p style="width:85%;word-wrap: break-word;">{{essentialInformation.phone}}</p>
        </span>
        <span class="typefaceSpan">
          <p style="white-space: nowrap;" class="watch_first">总 收 益 ：</p>
          <p style="width:85%;word-wrap: break-word;">{{essentialInformation.profit}}</p>
        </span>
        <span class="typefaceSpan">
          <p style="white-space: nowrap;" class="watch_first">注册时间 ：</p>
          <p style="width:85%;word-wrap: break-word;">{{essentialInformation.createTime}}</p>
        </span>
        <span class="typefaceSpan">
          <p style="white-space: nowrap;" class="watch_first">BD推广人员 ：</p>
          <p style="width:85%;word-wrap: break-word;">{{essentialInformation.bdCount}}</p>
        </span>
        <span class="typefaceSpan">
          <p style="white-space: nowrap;" class="watch_first">下级会员 ：</p>
          <p style="width:85%;word-wrap: break-word;">{{essentialInformation.vipCount}}</p>
        </span>
        <span class="typefaceSpan">
          <p style="white-space: nowrap;" class="watch_first">入驻企业 ：</p>
          <p style="width:85%;word-wrap: break-word;">{{essentialInformation.enterpriseCount}}</p>
        </span>
        <span class="typefaceSpan">
          <p style="white-space: nowrap;" class="watch_first">身　　份 ：</p>
          <p style="width:85%;word-wrap: break-word;">{{essentialInformation.identity}}</p>
        </span>
        <span class="typefaceSpan">
          <p style="white-space: nowrap;" class="watch_first">账户余额 ：</p>
          <p style="width:85%;word-wrap: break-word;">{{essentialInformation.balance}}</p>
        </span>
      </div>
    </div>
    <!-- 表格 -->
    <el-tabs type="card" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="提现记录" name="first"/>
      <el-tab-pane label="推广人员" name="second"/>
      <el-tab-pane label="入驻企业" name="third"/>
    </el-tabs>
    <div class="main_container">
      <!-- 提现记录 -->
      <div class="table_container" v-show="activeName=='first'">
        <el-table :data="WithdrawalRecordList" stripe border>
          <el-table-column label="提现日期" align="center">
            <template scope="scope">{{scope.row.applyTime}}</template>
          </el-table-column>
          <el-table-column label="绑定账户" align="center">
            <template scope="scope">{{scope.row.applyAccount}}</template>
          </el-table-column>
          <el-table-column label="提现金额" align="center">
            <template scope="scope">￥{{scope.row.amount}}</template>
          </el-table-column>
          <el-table-column label="提现状态" align="center">
            <template scope="scope">{{scope.row.state}}</template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handleTabOne"
        :page-size="10" :current-page="pageIndexTabOne" :total="totalTabOne" style="float: right;margin: 10px 0;"/>
      </div>
      <!-- 推广人员 -->
      <div class="table_container" v-show="activeName=='second'">
        <el-table :data="extensionList" stripe border>
          <el-table-column label="用户昵称" align="center">
            <template scope="scope">{{scope.row.name}}</template>
          </el-table-column>
          <el-table-column label="手机号" align="center">
            <template scope="scope">{{scope.row.phone}}</template>
          </el-table-column>
          <el-table-column label="性别" align="center">
            <template scope="scope">{{scope.row.sex}}</template>
          </el-table-column>
          <el-table-column label="注册时间" align="center">
            <template scope="scope">{{scope.row.createTime}}</template>
          </el-table-column>
          <el-table-column label="推广会员" align="center">
            <template scope="scope">{{scope.row.vipCount}}</template>
          </el-table-column>
          <el-table-column label="推广企业" align="center">
            <template scope="scope">{{scope.row.enterpriseCount}}</template>
          </el-table-column>
          <el-table-column label="提成" align="center">
            <template scope="scope">￥{{scope.row.commission}}</template>
          </el-table-column>
          <el-table-column label="佣金" align="center">
            <template scope="scope">￥{{scope.row.brokerage}}</template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handleTabTwo"
        :page-size="10" :current-page="pageIndexTabTwo" :total="totalTabTwo" style="float: right;margin: 10px 0;"/>
      </div>
      <!-- 入驻企业 -->
      <div class="table_container" v-show="activeName=='third'">
        <el-table :data="enterpriseList" stripe border>
          <el-table-column label="企业名称" align="center">
            <template scope="scope">{{scope.row.name}}</template>
          </el-table-column>
          <el-table-column label="真实姓名" align="center">
            <template scope="scope">{{scope.row.legalPerson}}</template>
          </el-table-column>
          <el-table-column label="联系方式" align="center">
            <template scope="scope">{{scope.row.legalPersonPhone}}</template>
          </el-table-column>
          <el-table-column label="性质" align="center">
            <template scope="scope">{{scope.row.enterpriseAttribute}}</template>
          </el-table-column>
          <el-table-column label="详细地址" align="center">
            <template scope="scope">{{scope.row.address}}</template>
          </el-table-column>
          <el-table-column label="品牌店铺" align="center">
            <template scope="scope">{{scope.row.storeCount}}</template>
          </el-table-column>
          <el-table-column label="平台佣金" align="center">
            <template scope="scope">￥{{scope.row.platformCommission}}</template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handleTabThree"
        :page-size="10" :current-page="pageIndexTabThree" :total="totalTabThree" style="float: right;margin: 10px 0;"/>
      </div>
    </div>
  </div>
  <!-- 添加合伙人-弹框 -->
  <el-dialog :title="hhrDialog" :visible.sync="isToExamine" :center="true" width="50%">
    <el-form>
      <el-form-item label="入驻城市 :" style="width:85%;" label-width="80px">
        <el-cascader v-model="chengshi" placeholder="请选择城市" style="background:#fff;width:100%"
        :options="optionDetails" filterable clearable @change="addHandleChangeDetails" :disabled="hhrDialog == '编辑合伙人'"/>
      </el-form-item>
      <el-form-item label="真实姓名 :" style="width:85%" label-width="80px">
        <el-input v-model="RealName" placeholder="请输入真实姓名 (20字以内)" maxlength="20"/>
      </el-form-item>
      <el-form-item label="手机号 :" style="width:85%;" label-width="80px">
        <el-input v-model="cellPhone" placeholder="请输入手机号" maxlength="11" style="width:75%"
        onkeyup="value=value.replace(/^\D*(\d*(?:\d{0})?).*$/g, '$1')"/>　<label style="float: right;"> 唯一验证标识</label>
      </el-form-item>
      <el-form-item label="身份证 :" style="width:85%;" label-width="80px">
        <el-input v-model="idCode" placeholder="请输入身份证" maxlength="18"/>
      </el-form-item>
      <el-form class="formItem">
        <el-form-item label="加盟费 :" style="width:40%;" label-width="80px">
          <el-input v-model="franchiseFee" placeholder="请输入加盟费" maxlength="10"
          onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
        </el-form-item>
        <el-form-item label="分佣比例 :" style="width:40%;" label-width="80px">
          <el-input v-model="commissionRate" placeholder="请输入分佣比例" maxlength="2"
          onkeyup="value=(value.replace(/\D/g,'')==''?'':parseInt(value))"/>
        </el-form-item>
      </el-form>
      <b style="display: block;text-align: center;">推广费分佣配置</b>
      <el-row style="margin-top: 10px;">
        <el-col :span="6">
          <el-form-item label="有创客 : 平台 :" style="width:44%;" label-width="100px">
            <el-input v-model="yckpt" placeholder="请输入" maxlength="3"
              onkeyup="value=value.replace(/[^\d\.]/g,'').replace('.','')">
              <i slot="suffix" style="font-style:normal;margin-right: 10px;">%</i>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="合伙人 :" style="width:44%;" label-width="100px">
            <el-input v-model="hhrOne" placeholder="请输入" maxlength="3"
              onkeyup="value=value.replace(/[^\d\.]/g,'').replace('.','')">
              <i slot="suffix" style="font-style:normal;margin-right: 10px;">%</i>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="创客 :" style="width:44%;" label-width="100px">
            <el-input v-model="chuangkeOne" placeholder="请输入" maxlength="3"
              onkeyup="value=value.replace(/[^\d\.]/g,'').replace('.','')">
              <i slot="suffix" style="font-style:normal;margin-right: 10px;">%</i>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="创客邀请人 :" style="width:44%;" label-width="100px">
            <el-input v-model="chuangkeTwo" placeholder="请输入" maxlength="3"
              onkeyup="value=value.replace(/[^\d\.]/g,'').replace('.','')">
              <i slot="suffix" style="font-style:normal;margin-right: 10px;">%</i>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="无创客 : 平台 :" style="width:44%;" label-width="100px">
            <el-input v-model="wckpt" placeholder="请输入" maxlength="3"
              onkeyup="value=value.replace(/[^\d\.]/g,'').replace('.','')">
              <i slot="suffix" style="font-style:normal;margin-right: 10px;">%</i>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="合伙人 :" style="width:44%;" label-width="100px">
            <el-input v-model="hhrTwo" placeholder="请输入" maxlength="3"
              onkeyup="value=value.replace(/[^\d\.]/g,'').replace('.','')">
              <i slot="suffix" style="font-style:normal;margin-right: 10px;">%</i>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 弹框按钮 -->
    <div style="text-align:center">
      <el-button @click="isToExamine = false">取消</el-button>
      <el-button type="danger" @click="editSubmit()">确定</el-button>
    </div>
  </el-dialog>

</section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { provincegetcountys } from "../../api/newOss";
import { getCityPartnerPaginationList, getCityPartnerDetails, getWithdrawRecord, getCityPartnerBD, getEnterprise,
 postCityPartner, getSettledCityList, getinfoId } from "../../api/attractInvestment";
export default {
  name: 'cityPartner',
  mixins: [alertTrends],
  data() {
    return {
      show3: true, // 查询区域默认展开
      peopleId: "", // 合伙人id
      dataList: [], // 查询列表
      pageIndex: 1,
      pageSize: 10,
      totalRowsCount: 0,
      filters: {
        cityPartnerName: "", // 姓名
        partnerPhone: "", // 手机号
        partnerGender: 0, // 性别
        provinceId: 0, // 省
        cityId: 0, // 市
        zoneId: 0, // 区县
      },
      genderArr: [
        {
          Id: 0,
          Name: "全部"
        },
        {
          Id: 1,
          Name: "男"
        },
        {
          Id: 2,
          Name: "女"
        }
      ],
      csOptions: [],

      isToExamine: false, // 弹框
      hhrDialog: '添加合伙人',
      chengshi: "", // 入驻城市
      optionDetails: [], // 入驻城市
      provinceDetailsId: 0, // 省
      cityDetailsId: 0, // 市
      zoneDetailsId: 0, // 区
      RealName: "", // 真实姓名
      cellPhone: "", // 手机号
      idCode: "", // 身份证
      franchiseFee: '', // 加盟费
      commissionRate: '', // 分佣比例

      yckpt: '', // 有创客平台
      hhrOne: '', // 合伙人1
      chuangkeOne: '', // 一级创客
      chuangkeTwo: '', // 二级创客
      wckpt: '', // 无创客平台
      hhrTwo: '', // 合伙人2

      isOrder: true, // 列表页
      isSeePartnerPopup: false, // 查看
      essentialInformation: [], // 详情基本信息
      activeName: 'first',

      WithdrawalRecordList: [], // 提现记录
      pageIndexTabOne: 1, // 提现记录分页
      pageSizeTabOne: 10,
      totalTabOne: 0,

      extensionList: [], // 推广人员
      pageIndexTabTwo: 1, // 推广人员分页
      pageSizeTabTwo: 10,
      totalTabTwo: 0,

      enterpriseList: [], // 入驻企业
      pageIndexTabThree: 1, // 入驻企业分页
      pageSizeTabThree: 10,
      totalTabThree: 0,
    }
  },
  methods: {
    //查询列表
    getInit() {
      let addParams = {
        name: this.filters.cityPartnerName, // 姓名
        phone: this.filters.partnerPhone, // 手机号
        sex: this.filters.partnerGender, // 性别：0全部、1男、2女
        provinceid: this.filters.provinceId, // 所属省份ID
        cityid: this.filters.cityId, // 所属城市ID
        countyid: this.filters.zoneId, // 所属区县ID
        pageIndex: this.pageIndex,// 页码
        pageSize: this.pageSize // 每页行数
      };
      getCityPartnerPaginationList(addParams).then(data => {
        this.dataList = data.resultObj.resultObj;
        this.totalRowsCount = data.resultObj.rowsCount;
      })
      .catch(err => {
        this.dataList = [];
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getInit();
    },
    // 显示主页
    showOrder() {
      this.isOrder = true; // 订单主页
      this.isSeePartnerPopup = false; // 详情页查看
    },
    // 添加合伙人
    addPartner(row) {
      this.hhrDialog = '添加合伙人';
      this.getlookupProvinceAndCity(); // 查询省市区级联数据
      this.isToExamine = true; // 详情弹框展示
      this.peopleId = '';
      this.chengshi = ""; // 入驻城市
      this.RealName = ""; // 真实姓名
      this.cellPhone = ""; // 手机号
      this.idCode = ""; // 身份证
      this.franchiseFee = ""; // 加盟费
      this.commissionRate = ""; // 分佣比例
      
      this.yckpt = 5; // 有创客平台
      this.hhrOne = 12; // 合伙人1
      this.chuangkeOne = 80; // 一级创客
      this.chuangkeTwo = 3; // 二级创客
      this.wckpt = 30; // 无创客平台
      this.hhrTwo = 70; // 合伙人2
      if(row){
      this.hhrDialog = '编辑合伙人';
        this.peopleId = row.id; // 合伙人id
        getinfoId('',row.id).then(data => {
          if (data.resultCode == 1) {
            let thisData = data.resultObj;
            this.provinceDetailsId = thisData.provinceId; // 省
            this.cityDetailsId = thisData.cityId; // 市
            this.zoneDetailsId = thisData.zoneId; // 区
            this.chengshi = [this.provinceDetailsId,this.cityDetailsId,this.zoneDetailsId]; // 省市区
            this.RealName = thisData.name; // 姓名
            this.cellPhone = thisData.phone; // 手机号
            this.idCode = thisData.idCode; // 身份证号
            this.franchiseFee = thisData.franchiseFee; // 加盟费
            this.commissionRate = thisData.commissionRate; // 分佣比例比例
            let tgyjpz1 = thisData.promoteCommissionConfigs.find(i=>i.configType == 1); // 推广佣金配置集合
              this.yckpt = tgyjpz1.platformRate;
              this.hhrOne = tgyjpz1.partnerRate;
              this.chuangkeOne = tgyjpz1.makerRate; // 一级创客
              this.chuangkeTwo = tgyjpz1.individualRate; // 二级创客
            let tgyjpz2 = thisData.promoteCommissionConfigs.find(i=>i.configType == 2); // 推广佣金配置集合
              this.wckpt = tgyjpz2.platformRate;
              this.hhrTwo = tgyjpz2.partnerRate;
          }
        })
      }
    },
    // 切换详情页tab
    handleClick(tab, event) {
      // console.log(tab, event);
      this.queryWithdrawalRecord(); // 查询合伙人提现记录
      this.queryExtension(); // 查询合伙人推广人员
      this.querySettledEnterprise(); // 查询合伙人入驻企业
    },
    // 查看
    cliSeePartner(row) {
      this.peopleId = row.id; // 合伙人id
      this.isOrder = false; // 订单主页
      this.isSeePartnerPopup = true; // 详情页查看
      this.getOrderDetail(); // 查看详情
      this.queryWithdrawalRecord(); // 查询合伙人提现记录
      this.queryExtension(); // 查询合伙人推广人员
      this.querySettledEnterprise(); // 查询合伙人入驻企业
      this.activeName = 'first';
    },
    // 新增&编辑城市合伙人
    editSubmit() {
      if(this.chengshi == "") {
        this.showAlert('请选择入驻城市');
        return false;
      }
      if(this.RealName == ""){
        this.showAlert('请输入真实姓名');
        return false;
      }
      if(this.cellPhone == "") {
        this.showAlert('请输入手机号');
        return false;
      }
      if(this.idCode == "") {
        this.showAlert('请输入身份证');
        return false;
      }
      if(this.franchiseFee == "") {
        this.showAlert('请输入加盟费');
        return false;
      }
      if(this.commissionRate == "") {
        this.showAlert('请输入分佣比例');
        return false;
      }
      if(this.yckpt === "") {
        this.showAlert('请输入有创客平台');
        return false;
      }
      if(this.hhrOne === "") {
        this.showAlert('请输入有创客合伙人');
        return false;
      }
      if(this.chuangkeOne === "") {
        this.showAlert('请输入一级创客');
        return false;
      }
      if(this.chuangkeOne === 0) {
        this.showAlert('一级创客不能为0');
        return false;
      }
      if(this.chuangkeTwo === "") {
        this.showAlert('请输入二级创客');
        return false;
      }
      if(Number(this.yckpt)+Number(this.hhrOne)+Number(this.chuangkeOne)+Number(this.chuangkeTwo) != 100) {
        this.showAlert('有创客分佣比例相加必须等于100%');
        return false;
      }
      if(this.wckpt === "") {
        this.showAlert('请输入无创客平台');
        return false;
      }
      if(this.hhrTwo === "") {
        this.showAlert('请输入无创客合伙人');
        return false;
      }
      if(Number(this.wckpt)+Number(this.hhrTwo) != 100) {
        this.showAlert('无创客分佣比例相加必须等于100%');
        return false;
      }
      let tgffypz = [
        {
          configType: 1, // 配置类型 1=有创客 2=无创客
          platformRate: this.yckpt, // 有创客平台
          partnerRate: this.hhrOne, // 有创客合伙人
          makerRate: this.chuangkeOne, // 一级创客
          individualRate: this.chuangkeTwo, // 二级创客
        },{
          configType: 2, // 配置类型 1=有创客 2=无创客
          platformRate: this.wckpt, // 无创客平台
          partnerRate: this.hhrTwo, // 无创客合伙人
          makerRate: 0, // 创客佣金比例
        }
      ]
      var loginParams = {
        id: this.peopleId?this.peopleId:0, // 城市合伙人ID 编辑操作时需要传入
        creatorId: localStorage.Id, // 创建人Id
        name: this.RealName, // 真实姓名
        phone: this.cellPhone, // 手机号
        idCode: this.idCode, // 身份证号
        provinceId: this.provinceDetailsId, // 省Id
        cityId: this.cityDetailsId, // 市Id
        zoneId: this.zoneDetailsId, // 区Id
        franchiseFee: Number(this.franchiseFee), // 加盟费
        commissionRate: Number(this.commissionRate), // 分佣比例
        promoteCommissionConfigs: tgffypz, // 推广费分佣配置集合
      };
      postCityPartner(loginParams).then(data => {
        if (data.resultCode == 1) {
          this.showAlert('操作成功', 'success');
          this.isToExamine = false;
          this.getInit();
        }
      })
    },
    // 查看详情
    getOrderDetail(){
      var addParams = {
        id: this.peopleId // 合伙人id
      };
      getCityPartnerDetails(addParams).then(data => {
        this.essentialInformation = data.resultObj;
      })
    },
    // 查询合伙人提现记录
    queryWithdrawalRecord(){
      var addParams = {
        id: this.peopleId, // 合伙人id
        pageIndex: this.pageIndexTabOne,// 页码
        pageSize: this.pageSizeTabOne // 每页行数
      };
      getWithdrawRecord(addParams).then(data => {
        if(data) {
          if (data.resultCode == 1) {
            this.WithdrawalRecordList = data.resultObj.resultObj;
            this.totalTabOne = data.resultObj.rowsCount; // 总行数
          } else {
            this.WithdrawalRecordList = [];
          }
        } else {
            this.WithdrawalRecordList = [];
        }
      })
    },
    // 查询tab1 分页
    handleTabOne(val) {
      this.pageIndexTabOne = val;
      this.queryWithdrawalRecord();
    },
    // 查询合伙人推广人员
    queryExtension(){
      var addParams = {
        id: this.peopleId, // 合伙人id
        pageIndex: this.pageIndexTabTwo,// 页码
        pageSize: this.pageSizeTabTwo // 每页行数
      };
      getCityPartnerBD(addParams).then(data => {
        if(data) {
          if (data.resultCode == 1) {
            this.extensionList = data.resultObj.resultObj;
            this.totalTabTwo = data.resultObj.rowsCount; // 总行数
          } else {
            this.extensionList = [];
          }
        } else {
          this.extensionList = [];
        }
      })
    },
    // 查询tab2 分页
    handleTabTwo(val) {
      this.pageIndexTabTwo = val;
      this.queryExtension();
    },
    // 查询合伙人入驻企业
    querySettledEnterprise(){
      var addParams = {
        id: this.peopleId, // 合伙人id
        pageIndex: this.pageIndexTabThree,// 页码
        pageSize: this.pageSizeTabThree // 每页行数
      };
      getEnterprise(addParams).then(data => {
        if(data) {
          if (data.resultCode == 1) {
            this.enterpriseList = data.resultObj.resultObj;
            this.totalTabThree = data.resultObj.rowsCount; // 总行数
          } else {
            this.enterpriseList = [];
          }
        } else {
          this.enterpriseList = [];
        }
      })
    },
    // 查询tab3 分页
    handleTabThree(val) {
      this.pageIndexTabThree = val;
      this.querySettledEnterprise();
    },
    // 入驻城市
    addHandleChangeDetails(val) {
      this.provinceDetailsId = val[0];
      this.cityDetailsId = val[1];
      this.zoneDetailsId = val[2];
    },
    // 查找省+市+区
    getlookupProvinceAndCity() {
      getSettledCityList().then(data => {
        let that = this;
        let provinceAndCityAndarea = [];
        data.resultObj.map(item => {
          // 所有省 查当前省下级市
          let provinceData = {value:item.id,label:item.name,children:[]};
          provinceAndCityAndarea.push(provinceData);
          // 所有市
          item.node.map(city => {
            let cityData = {value:city.id, label:city.name,children:[]};
            provinceData.children.push(cityData);
            // 区
            city.node.map(zone => {
              cityData.children.push({value:zone.id, label:zone.name});
            })
          })
        });
        that.optionDetails = provinceAndCityAndarea;
      })
    },
    // 重置
    fnReset() {
      this.filters = {
        cityPartnerName: "", // 姓名
        partnerPhone: "", // 手机号
        partnerGender: 0, // 性别
        provinceId: 0,
        cityId: 0,
        zoneId: 0,
      }
      // this.pageIndex = 1;
      // this.getInit();
    },
    //查询
    onSubmit() {
      this.pageIndex = 1;
      this.getInit();
    },
    // 请选择省市
    handleChangesscs(val) {
      this.filters.provinceId = val[0]; // 省
      this.filters.cityId = val[1]; // 市
      this.filters.zoneId = val[2]; // 区
    },
    // 查找省市区
    getprovince() {
      var loginParams = {
        isopen: 1, // 是否开放 -1=查全部 1=开放、0=未开放
      };
      provincegetcountys(loginParams).then(data => {
        // 需要给区县加全市 用这段
        const provinceOptions = [];
        data.resultObj.forEach(item => {
          const province = { value: item.pid, label: item.pname, children: [] };
          item.citys.forEach(city => {
            // 添加表示“全市”的选项
            const allCityOption = {
              value: 0, label: "全市"
            };
            const cityObj = {
              value: city.cid, label: city.cname,
              children: [allCityOption].concat(city.countys.map(zone => ({
                value: zone.scid, label: zone.scname
              })))
            };
            province.children.push(cityObj);
          });
          provinceOptions.push(province);
        });
        this.csOptions = provinceOptions;
        this.csOptions.unshift({
          value: 0, label: "全国"
        });
      });
    },
  },
  created() {
    this.getInit(); // 查询列表
    this.getprovince(); // 获取省市区
  }
}
</script>
<style scoped>
/* 添加合伙人弹框内容 */
.formItem {
  width: 85%;
  display:flex;
  justify-content: space-between;
}
.typefaceSpan {
  width:15%;
  display:flex;
  margin: 0 auto;
}
.watch_first {
  color: #888;
  width: 90px;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// cityPartner.vue?2e3a1e3c